"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettings = void 0;
var tslib_1 = require("tslib");
var private_catalog_service_1 = require("../../../catalog-services/private-catalog-service");
var PrivateSettings = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateSettings, _super);
    function PrivateSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivateSettings.prototype.getSettings = function (requestConfig) {
        return this.get('/catalog/settings', requestConfig);
    };
    /**
     * Either create new or update existing settings
     * @param {Settings} settings
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<Settings>>}
     * @example
     *
     * const updatedSettings = await new PrivateSettings()
     *  .update({settingName: true})
     *  .then(response => response.data);
     */
    PrivateSettings.prototype.update = function (settings, requestConfig) {
        return this.post('/catalog/settings', settings, tslib_1.__assign({}, requestConfig));
    };
    /**
     * Reset settings
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse>}
     * @example
     *
     * const service = new PrivateSettings();
     * await service.reset();
     *
     * const settings = await service
     *  .get()
     *  .then(response => response.data);
     *
     * Object.keys(settings).length === 0 // true
     */
    PrivateSettings.prototype.reset = function (requestConfig) {
        return this.delete('/catalog/settings', requestConfig);
    };
    return PrivateSettings;
}(private_catalog_service_1.PrivateCatalogService));
exports.PrivateSettings = PrivateSettings;
//# sourceMappingURL=settings.js.map